exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "nav[data-v-c1402dc2]{background-color:#003f87;bottom:0;min-width:5vw;overflow-y:auto;position:absolute;top:0;transform:translate3d(-100%,0,0);transition:transform .4s ease;width:280px;z-index:104}nav.active[data-v-c1402dc2]{transform:translateZ(0);transition:transform .4s ease;visibility:visible}nav[data-v-c1402dc2] header{box-shadow:none;padding:.3rem 0 .25rem;position:relative;top:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c1402dc2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/nav/Nav.vue
// module id = ./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-c1402dc2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/nav/Nav.vue
// module chunks = 0